import { useEffect } from "react";
import { Row, Col } from "react-flexbox-grid";
import { useGlobalContext } from "context/GlobalContext";
import { useHistory, useParams } from "react-router-dom";
import { withLoader } from "HOC";

import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const ReportSuccess = ({ setLoading }) => {
  const gContext = useGlobalContext();
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <Row center="xs" middle="xs" className="min-vh-100">
      <Col md={12} className="mt4">
        <Row center="xs">
          <CheckCircleIcon color="primary" style={{ height: 94, width: 94 }} />
        </Row>
        <Row center="xs">
          <Typography variant="h6" color="secondary">
            Reporte levantado con EXITO
          </Typography>
        </Row>
        <Row center="xs" className="mt2">
          <Typography variant="body2" color="textPrimary">
            Gracias por levantar tu reporte, en breve un ejecutivo le dara
            seguimiento, tu trabajo es muy importante.
          </Typography>
        </Row>
        <Row center="xs" className="mt2">
          <Typography variant="body2" color="textPrimary">
            Recuerda que puedes seguir el estatus de éste reporte en la sección
            Mis reportes
          </Typography>
        </Row>
        <Row center="xs" className="mt3 mb3">
          <Button
            variant="contained"
            color="primary"
            className="w-100"
            onClick={() => gContext.toggleChatModal(id)}
            style={{ maxWidth: 320 }}
          >
            Enviar comentarios adicionales
          </Button>
        </Row>
        <Row center="xs" className="mt3 mb3">
          <Button
            variant="contained"
            color="secondary"
            className="w-100"
            onClick={() => history.push("/")}
            style={{ maxWidth: 320 }}
          >
            Regresar
          </Button>
        </Row>
      </Col>
    </Row>
  );
};

export default withLoader(ReportSuccess, "Cargando...");
